<template>
  <v-autocomplete
    v-model="params[type]"
    @change="applyFilter"
    :no-data-text="$t('appointment.filters.noData')"
    :search-input.sync="search"
    :item-text="itemText"
    :multiple="multiple"
    :item-value="value"
    :loading="loading"
    :items="items"
    :label="label"
    :disabled="disabled"
    :hide-no-data="hideNoData"
    :prepend-inner-icon="prependInnerIcon"
    :append-icon="appendIcon"
    autocomplete="one-time-code"
    ref="input"
    return-object
    single-line
    clearable
    outlined
    chips
    small
    dense
  >
    <template v-slot:selection="data">
      <span class="d-block text-truncate text-comma mr-2">
        {{ data.item.name }}
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import store from '@/store'

export default {
  name: 'FilterAutocompleteObject',

  props: {
    fetchData: {
      type: Function,
      required: true,
    },

    items: {
      type: Array,
      require: true,
    },

    label: {
      type: String,
      default: 'Filtro',
    },

    type: {
      type: String,
      required: true,
    },

    value: {
      type: String,
      default: 'value',
    },

    itemText: {
      default: 'name',
    },

    loading: {
      type: Boolean,
      default: false,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    asyncSearch: {
      type: Function,
      required: false,
    },

    disabled: {
      required: false,
      default: false,
    },

    hideNoData: {
      type: Boolean,
      default: false,
    },

    prependInnerIcon: {
      type: String,
      default: '',
    },

    appendIcon: {
      type: String,
      default: '$dropdown'
    }
  },

  watch: {
    search(value) {
      this.asyncSearch && this.handleAsyncSearch(value)
    },
  },

  computed: {
    ...mapGetters(['filters']),
  },

  methods: {
    ...mapMutations(['setFilters', 'setCurrentPage']),

    applyFilter() {
      if (this.asyncFilter) {
        this.handleAsyncSearch()
        return
      }

      this.handleFilter()
    },

    handleFilter() {
      this.selectedItems[this.type] = []

      if (this.params[this.type]) {
        this.params[this.type].forEach((item) => {
          this.selectedItems[this.type].push(item.id)
        })
      }

      this.$nextTick(() => {
        this.setFilters({ ...store.getters.filters, ...this.selectedItems })
        this.recoverLostItems()
        this.setCurrentPage(1)
        this.fetchData()
      })
    },

    recoverLostItems() {
      if (this.params[this.type]) {
        this.params[this.type].forEach(selectedItem => {
          if (this.items.filter(item => item.id == selectedItem.id).length <= 0) {
            this.items.push(selectedItem)
          }
        })
      }
    },

    clearFilter() {
      this.params[this.type] = null
      this.handleFilter()
    },

    handleAsyncSearch(value) {
      clearTimeout(this._customTimer)

      this._customTimer = setTimeout(() => {
        this.asyncSearch(value)
      }, 750)
    },

    clearInput() {
      this.$refs.input.reset()
    }
  },

  data() {
    return {
      params: {},
      selectedItems: {},
      search: null,
      _timer: null,
      _customTimer: null,
    }
  },
}
</script>
